export class Chat {
    codigo: number;
    cotizacion: string;
    partida: string;
    expedicion: string;
    entrada: number;
    usuario: string;
    mensaje: string;
    fecha: string;
    leido: boolean;
    mensajeDesdeMyXGL: boolean;
    idUsuarioCreacion: number;
    leidoMyXGL: boolean;
    esArchivo: boolean;
    archivo: string;
    tipoArchivo: number;
    nombreArchivo: string;
    refCliente: string;
    horaUltimoMensaje: string;
    referenciaCliente: string;
    tipo: string;
    icono: string;
    
    prefijo: string;
    ultimoMensaje: string;
    ultimaFecha: Date;
}